<template>
    <div class="pad">
      <section class="page-section">

        <button class="btn  hint--left" aria-label="Connect Wallet" @click="connect">


          <span v-if="isWalletConnected">Wallet Connected</span>
          <span v-else>Connect Wallet </span>

        </button>
        <p></p>

        <p v-if="isWalletConnected">Address: <strong>0xC3f5d5b09F6EB74A4a98BC694b08025Cfe5b1884</strong></p>

      </section>
      <section class="page-section">
        <h2>Unicorn Name</h2>
        <input type="text" class="title-input" placeholder="My Swag Unicorn" v-model="title">

        <div class="dialogue-text"><h2> </h2></div>
        <h2>
          <a @click="showHelp">
            <svg viewBox="0 0 24 24">
              <path d="M15.07,11.25L14.17,12.17C13.45,12.89 13,13.5 13,15H11V14.5C11,13.39 11.45,12.39 12.17,11.67L13.41,10.41C13.78,10.05 14,9.55 14,9C14,7.89 13.1,7 12,7A2,2 0 0,0 10,9H8A4,4 0 0,1 12,5A4,4 0 0,1 16,9C16,9.88 15.64,10.67 15.07,11.25M13,19H11V17H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z" />
            </svg>
          </a>
        </h2>
<!--        <textarea v-model="notes" class="dialogue-input" id="" cols="30" rows="10"></textarea>-->

        <h3>Image URL</h3>
        <input type="text" class="url-input"  v-model="imgUrl">
        <div class="dialogue-text">
        <p></p>
        </div>
<!--        <img :src="https://unicorn-nfts.s3.amazonaws.com/swag-unicorn.png">-->
<!--        https://unicorn-nfts.s3.amazonaws.com/happy-unicorn.png-->

        <p v-if="imgUrl.length > 0"><img v-bind:src="imgUrl" width="300" height="300"></p>
<!--        <button @click="showImage">Show</button>-->

        <button class="btn  hint--right" aria-label="Mint" @click="mint">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" aria-labelledby="title"
               aria-describedby="desc" role="img" xmlns:xlink="http://www.w3.org/1999/xlink">
            <title>Copy</title>
            <desc>A line styled icon from Orion Icon Library.</desc>
            <path data-name="layer2"
                  fill="none" stroke="#202020" stroke-miterlimit="10" stroke-width="2" d="M16 48H2V2h46v14"
                  stroke-linejoin="round" stroke-linecap="round"></path>
            <path data-name="layer1" fill="none" stroke="#202020" stroke-miterlimit="10"
                  stroke-width="2" d="M16 16h46v46H16z" stroke-linejoin="round" stroke-linecap="round"></path>
          </svg>
          <span>mint</span>
        </button>

<!--        <p v-if="openSeaLink.length > 0">-->
<!--          <a href={{openSeaLink}} target="_blank">View minted NFT in opensea</a>-->
<!--        </p>-->

      </section>

      <div class="page-section">
        <h2>Send to your friend!</h2>
        <input type="text" class="email-input" placeholder="email" v-model="receiverEmail">




        <button class="btn  hint--right" aria-label="send" @click="send">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" aria-labelledby="title"
               aria-describedby="desc" role="img" xmlns:xlink="http://www.w3.org/1999/xlink">
            <title>Send Email</title>
            <desc>A line styled icon from Orion Icon Library.</desc>
            <path data-name="layer2"
                  fill="none" stroke="#202020" stroke-miterlimit="10" stroke-width="2" d="M62 16H23.6L16 48h38.4L62 16z"></path>
            <path data-name="layer2" fill="none" stroke="#202020" stroke-miterlimit="10"
                  stroke-width="2" d="M23.6 16l14.9 22L62 16M16 48l19.2-14.8M54.4 48L42.9 33.8"></path>
            <path data-name="layer1" fill="none" stroke="#202020" stroke-miterlimit="10"
                  stroke-width="2" d="M2 24h11.9M2 32h10M2 40h8"></path>
          </svg>
          <span>send</span>
        </button>


      </div>

      <modal :is-visible.sync="isHelpModalVisible">
        <h2>Some help regarding Creation</h2>
        <p>Enter an image url here !</p>
      </modal>

      <modal :is-visible.sync="isMintedModalVisible">
        <h2>🎉Congratulations!</h2>
        <h3>You have successfully minted a 🦄 NFT</h3>
        <p><a href={{openSeaLink}} target="_blank">Click here to view it at Opensea</a></p>
      </modal>

      <modal :is-visible.sync="isSendModalVisble">
        <h2>Sent to aliceworksgreat@gmail.com!</h2>
        <h3>Your friend would receive notification about 🦄 NFT shortly!</h3>

      </modal>

<!--      <modal :is-visible.sync="isWalletConnected">-->
<!--        <h2>Wallet connected !</h2>-->
<!--        <h3>Your wallet address is <strong>0xC3f5d5b09F6EB74A4a98BC694b08025Cfe5b1884</strong> </h3>-->

<!--      </modal>-->


    </div>
</template>

<script>
import { auth } from '../Auth.js';
import notificationStore from '../NotificationStore.js';
import Modal from '../Modal.vue';
const axios = require('axios').default;
//const AWS = require('aws-sdk');
//const sgMail = require('@sendgrid/mail');

export default {
  components: { Modal },

  data () {
    return {
      title: '',
      notes: '',
      imgUrl: '',
      wallet: '0xC3f5d5b09F6EB74A4a98BC694b08025Cfe5b1884',
      transHash: '',
      contractAddr: '',
      openSeaLink: '',
      receiverEmail: '',
      isHelpModalVisible: false,
      isWalletConnected: false,
      isSendModalVisble: false,
      isMintedModalVisible: false,
      isShown: false
    }
  },

  route: {
    data: function (transition) {
      var self = this;
      var itemId = transition.to.params.itemId;

      if (itemId) {
        firebase.database().ref('/items/' + itemId).once('value').then(function (result) {
          var item = result.val();
          self.notes = item.notes;
          self.title = item.title;
          self.imgUrl = item.imgUrl;
          self.wallet = item.wallet;
          self.transHash = item.transHash;
          self.openSeaLink = item.openSeaLink;
          self.contractAddr = item.contractAddr;
        })
      } else {
        // TODO: Add sample actors
        this.title = '';
        this.imgUrl= '';
        this.dialogue = '1: Hello!\n1: I am a dummy character\n2: Mee too!\n1: Delete and add characters of your own\n2: Or simply play with us!';
      }
    }
  },

  created () {
    var self = this;

    document.title = 'Create';
  },

  methods: {
    showHelp () {
      this.isHelpModalVisible = true;
    },

    saveFirstTime () {
      var self = this,
        newItemKey = firebase.database().ref().child('items').push().key,
        userId = firebase.auth().currentUser.uid;

      firebase.database().ref('items/' + newItemKey).set({
        title: self.title || 'Untitled Item',
        notes: self.notes,
        imgUrl: self.imgUrl,
        wallet: self.wallet,
        transHash: self.transHash,
        contractAddr: self.contractAddr,
        openSeaLink: self.openSeaLink,
        createdBy: userId,
        createdOn: Date.now()
      }).then(function () {
        console.log('saved item', newItemKey);

        // Save new item with user too.
        firebase.database().ref('users/' + userId).child('items').child(newItemKey).set(true).then(function () {
          self.showSaveNotification();
          self.$route.router.go({ name: 'edit', params: { itemId: newItemKey }});
        });
      });
    },

    connect() {
      this.isWalletConnected = true;
    },

    mint() {
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': '9f8c7a7d-9552-44a6-8c72-d2f68feffa3c'
      };
      const data = {
        "chain": "rinkeby",
        "name": this.title,
        "description": this.title,
        "file_url": this.imgUrl,
        "mint_to_address": this.wallet
      }

      console.log('mint function');
      console.log(this.title);
      console.log(this.imgUrl);
      console.log(this.wallet);

      axios.post('https://api.nftport.xyz/v0/mints/easy/urls'
              , data,{
                headers: headers
              }).then((response) => {

                console.log('Response:====' + response);
                console.log(response);
                console.log('contract_addres: ==' + response.data.contract_address);
                let res = response.data;
                console.log('res');
                console.log(res);

                this.transHash = res.transaction_hash;
                this.contractAddr = res.contract_address;

                // async function setMintModal() {
                //   while (true) {
                //     if (this.openSeaLink.length > 0) {
                //       this.isMintedModalVisible = true;
                //       console.log('is minted modal visible');
                //       await null;
                //     }
                //   }
                // }
                // setMintModal();
                // setTimeout(() =>(this.openSeaLink.length > 0), 420);

       }).catch((error) => {
        console.log(error);
      });

      // retrieve the minted NFT call
      // link to opensea = opensea url + contract address + token id

      const getMintedUrl = 'https://api.nftport.xyz/v0/mints/' + this.transHash;
      console.log('get minted url: ');
      console.log(getMintedUrl);
      axios.get(getMintedUrl,{
        params:{
          "chain": "rinkeby"
        },
        headers: headers
      }).then((response) => {
        console.log(response);
        let res = response.data;
        this.openSeaLink = 'https://testnets.opensea.io/assets/' + res.contract_address + '/' + res.token_id;
        console.log('opensea link: ');
        console.log(this.openSeaLink);
        this.isMintedModalVisible = true;

      }).catch((error) => {
        console.log(error);
      });

      // save to db
      this.save();

    },

    showImage() {
      console.log('image url:');
      console.log(this.imgUrl);
      this.isShown = true;
      return this.imgUrl;
    },

    send() {
      this.isSendModalVisble = true;
      //sendgrid
      sgMail.setApiKey(process.env.SENDGRID_API_KEY);
      // const msg = {
      //   to: 'alicemx01@gmail.com', // Change to your recipient
      //   from: 'aliceworksgreat@gmail.com', // Change to your verified sender
      //   subject: 'New Unicorn NFT Alert!!! {{name}}!',
      //   text: 'Dear {{name}},\r\nView your magical creature at this link:'  + this.openSeaLink,
      //   html: '<strong>New Unicorn NFT Alert!!!</strong>',
      // };sgMail.setApiKey(process.env.SENDGRID_API_KEY)
      const msg = {
        to: 'aliceworksgreat@gmail.com', // Change to your recipient
        from: 'alicemx01@gmail.com', // Change to your verified sender
        subject: 'Sending with SendGrid is Fun',
        text: 'and easy to do anywhere, even with Node.js',
        html: '<strong>and easy to do anywhere, even with Node.js</strong>',
      }
      sgMail
              .send(msg)
              .then(() => {
                console.log('Email sent')
              })
              .catch((error) => {
                console.error(error)
              });



//
//
//       AWS.config.update({accessKeyId: '', secretAccessKey:'+', region: 'us-east-1'});
//       //AWS.config.loadFromPath('./aws-config.json');
//       let template = {"Template": {
//           "TemplateName": "sendUnicorn",
//           "SubjectPart": "New Unicorn NFT Alert!!! {{name}}!",
//           "HtmlPart": "<h1>Hello {{name}},</h1><p>You have received a unicorn NFT from your friend {{user}}.</p>",
//           "TextPart": "Dear {{name}},\r\nView your magical creature at this link: {{openSeaLink}}."
//         }};
//       // Create the promise and SES service object
//     //   var templatePromise = new AWS.SES({apiVersion: '2010-12-01'}).createTemplate(template).promise();
//     //
//     // // Handle promise's fulfilled/rejected states
//     //   templatePromise.then(
//     //           function(data) {
//     //             console.log(data);
//     //           }).catch(
//     //           function(err) {
//     //             console.error(err, err.stack);
//     //           });
//
//       let params = {
//         Destinations: [ /* required */
//           {
//             Destination: { /* required */
//               CcAddresses: [
//
//               ],
//               ToAddresses: [
//                 this.receiverEmail
//               ]
//             },
//             ReplacementTemplateData: '{ \"name\":\"Michelle\", \"user\":\"Alice\" }'
//           },
//         ],
//         Source: 'aliceworksgreat@gmail.com', /* required */
//         Template: 'sendUnicorn', /* required */
//         DefaultTemplateData: '{ \"name\":\"Michelle\", \"user\":\"Alice\" }',
//         ReplyToAddresses: [
//           'aliceworksgreat@gmail.com'
//         ]
//       };
//
//       // Create the promise and SES service object
//       let sendPromise = new AWS.SES({apiVersion: '2010-12-01'}).sendBulkTemplatedEmail(params).promise();
//
// // Handle promise's fulfilled/rejected states
//       sendPromise.then(
//               function(data) {
//                 console.log('send email: ===');
//                 console.log(data);
//               }).catch(
//               function(err) {
//                 console.log(err, err.stack);
//               });



    },

    save () {
      var self = this,
        itemId = this.$route.params.itemId;

      if (!itemId) {
        this.saveFirstTime();
        return;
      }

      firebase.database().ref('items/' + itemId).update({
        title: this.title || 'Untitled',
        notes: this.notes,
        imgUrl: this.imgUrl,
        wallet: this.wallet,
        transHash: this.transHash,
        contractAddr: this.contractAddr,
        openSeaLink: this.openSeaLink,
        updatedOn: Date.now()
      }).then(self.showSaveNotification);
    },

    showSaveNotification () {
      notificationStore.add({
        title: 'Item Saved!'
      });
    }
  }
}
</script>

<style>

@media screen and (max-width: 700px) {
  .title-input {
    width: 100%;
  }
  .notes-input {
    padding: 10px;
    width: 100%;
  }
}
.fixed-btns {
  position: fixed;
  right: 0;
  display: flex;
  flex-direction: column;
  padding: 40px;
  justify-content: right;
  text-align: right;
  top: 35%;
}
.fixed-btns > .btn {
  margin: 10px 0;
}
@media screen and (max-width: 800px) {
  .fixed-btns {
    padding: 10px;
  }
  .fixed-btns > .btn {
    border-radius: 50%;
    padding: 6px 11px;
  }
  .fixed-btns > .btn > span {
    display: none;
  }
}
.dialogue-text {
  color: blueviolet;
}
</style>



// WEBPACK FOOTER //
// Edit.vue?5b39760a